export default function validateAsesorForm(fieldName, fieldValue, fields) {
    let validationErrors = {};
    let numberOfErrors = 0;
    if (fieldName !== null || fieldValue !== null) {
        switch (fieldName) {
            case "ase_nombre":
                if (!fieldValue) {
                    validationErrors.ase_nombre = "El nombre del asesor es obligatorio";
                    numberOfErrors += 1;
                }
                break;
            case "ase_tipide":
                if (!fieldValue) {
                    validationErrors.ase_tipide = "Escoja el tipo identificación";
                    numberOfErrors += 1;
                }
                break;
            case "ase_numide":
                if (!fieldValue) {
                    validationErrors.ase_numide = "El número de identificación es obligatorio";
                    numberOfErrors += 1;
                }
                break;
            case "ase_email":
                if (!fieldValue) {
                    validationErrors.ase_email = "El email del asesor es obligatorio";
                    numberOfErrors += 1;
                }
                break;
            case "password":
                if (!fieldValue) {
                    validationErrors.password = "La contraseña del asesor es obligatoria";
                    numberOfErrors += 1;
                }
                break;
            case "ase_telefono":
                if (!fieldValue) {
                    validationErrors.ase_telefono = "El primer teléfono es obligatorio";
                    numberOfErrors += 1;
                }
                break;
            case "ase_telefono2":
                if (!fieldValue) {
                    validationErrors.ase_telefono2 = "El segundo teléfono es obligatorio";
                    numberOfErrors += 1;
                }
                break;
            case "ase_rol":
                if (!fieldValue) {
                    validationErrors.ase_rol = "Escoger el rol del asesor es obligatorio";
                    numberOfErrors += 1;
                }
                break;


            default:
                break;
        }
    } else {
        if (!fields.ase_nombre) {
            validationErrors.ase_nombre =  "El nombre del asesor es obligatorio";
            numberOfErrors += 1;
        }
        if (!fields.ase_tipide) {
            validationErrors.ase_tipide = "Escoja el tipo identificación";
            numberOfErrors += 1;
        }
        if (!fields.ase_numide) {
            validationErrors.ase_numide = "El número de identificación es obligatorio";
            numberOfErrors += 1;
        }

        if (!fields.ase_email) {
            validationErrors.ase_email = "El email del asesor es obligatorio";
            numberOfErrors += 1;
        }

        if (!fields.password) {
            validationErrors.password = "La contraseña del asesor es obligatoria CRV";
            numberOfErrors += 1;
        }

        if (!fields.ase_telefono) {
            validationErrors.ase_telefono = "El primer teléfono es obligatorio";
            numberOfErrors += 1;
        }

        if (!fields.ase_telefono2) {
            validationErrors.ase_telefono2 = "El segundo teléfono es obligatorio";
            numberOfErrors += 1;
        }
        if (!fields.ase_rol) {
            validationErrors.ase_rol = "Escoger el rol del asesor es obligatorio";
            numberOfErrors += 1;
        }

 

    }

    return { validationErrors, numberOfErrors }
}